import { EventBus } from "../../../eventbus";

export default {
  props: {
    label: String,
    icon: String,
    parentId: String,
    defaultActive: Boolean,
  },
  data() {
    return {
      active: this.defaultActive,
    };
  },
  created() {
    //file-sort-settings
    EventBus.$on(`${this.$options.name}-update`, (data) => {
      if (data.parentId === this.parentId) {
        //is same section
        this.active = data.label === this.label;
      }
    });
  },
  methods: {
    updateViewOptions(e) {
      e.preventDefault();

      EventBus.$emit(`${this.$options.name}-update`, {
        label: this.label,
        parentId: this.parentId,
      });
    },
  },
  watch: {
    defaultActive() {
      this.active = this.defaultActive;
    },
  },
};
